const course = {
  /** No Courses */
  you_have_not_created_a_course_yet: 'You have not created a course yet.',
  click_here_to_launch_acadly_s_web_application_and_create_a_course:
    "Click <1>here</1> to launch Acadly's web application and create a course.",
  your_first_course_is_free: 'Your first course is free!',

  /** Course Widget */
  course_admin: 'Course Admin',
  course_instructor: 'Course Instructor',
  next_lecture: 'Next lecture',
  not_scheduled: 'Not scheduled',

  /** Errors */
  unable_to_fetch_courses: 'Unable to fetch courses',
} as const;

export default course;
